import { apiClient } from '@core/api';

/***********************************************************
    Countries are returned in the following format:

    {
        'country_id': 8,
        'country_name': 'United States',
        'country_code': 'US',
        'country_currency': 'USD'
    }
***********************************************************/

export const requestCountries = () => {
  // Make sure we only ever request this once per session.
  if (window.__countriesRequested === true) {
    return window.__countriesPromise;
  }

  // Grab a list of countries from the API and store them.
  window.__countriesPromise = apiClient('countries')
    .get()
    .then((response) => {
      // Store this value globally for code that operates synchronously
      window.__countryList = response;

      // Async response
      return window.__countryList;
    });

  window.__countriesRequested = true;

  return window.__countriesPromise;
};

export const findCountry = (search) => {
  search = String(search).toLowerCase();

  if (!window.__countryList) {
    return {};
  }

  // Search our country list for any exact match on any field.
  // Return an empty object otherwise.
  return (
    window.__countryList.filter((country) =>
      Object.entries(country)
        .map(([_key, value]) => String(value).toLowerCase())
        .includes(search)
    )?.[0] || {}
  );
};
